import LoadingState from '@/api/LoadingState';

const state = {
  current: [],
  result: {},
  loadingState: LoadingState.INITIAL
}

export default state
